import { render, staticRenderFns } from "./CopyRightAndWebInfor.vue?vue&type=template&id=4b2655a4"
import script from "./CopyRightAndWebInfor.vue?vue&type=script&lang=js"
export * from "./CopyRightAndWebInfor.vue?vue&type=script&lang=js"
import style0 from "./CopyRightAndWebInfor.vue?vue&type=style&index=0&id=4b2655a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports